import React, { useState } from "react";
import "./CVPanier.scss";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { FaTrash } from "react-icons/fa";
import Modal from "Components/Modal/Modal";
import { InputText } from "primereact/inputtext";
import { FaPaperPlane } from "react-icons/fa";

import BtnBlanc from "Components/Boutons/BtnBlanc/btn-blanc";
import { updateMenu } from "Redux/Actions/menuActions";
import axios from "axios";
import { updateCVs } from "Redux/Actions/cvsActions";
import CV from "Components/CV/CV/CV";
import { useEffect } from "react";

const CVPanier = (props) => {
  const API_LINK = process.env.REACT_APP_BASE_URL_API.split("/api")[0];

  const [visibleModal, setVisibleModal] = useState(false);
  const [visibleModalDetail, setVisibleModalDetail] = useState(false);

  const [basketResumeList, setBasketResumeList] = useState([]);
  const [emailList, setEmailList] = useState("");

  // Avec l'id du panier transmis par Paniers.js, set la variable avec la liste des id des CV's qu'elle contient
  let newBasketResumeItems = props.cvs.cvsBasket.filter(
    (basket) => basket.id === props.basketId
  )[0].basketResumeItems;
  // Au changement de la liste d'id de CV, lance la conversion vers une liste de user
  useEffect(() => {
    createBasketResumeList();
  }, [newBasketResumeItems]);

  // D'une liste d'id de CV ressort une liste de carte user associée qui sera affichée
  const createBasketResumeList = () => {
    let listOfResume = [];
    newBasketResumeItems.forEach((resume) => listOfResume.push(resume.resume));
    setBasketResumeList(listOfResume);
  };

  // Fonction qui ajoute un CV à un panier (déclenchée dans la pop-up panier dans la CVThèque)
  const addResume = (id, basketId) => {
    // Variable qui détermine si le panier contient déjà ce CV
    const isContaining = newBasketResumeItems.some(
      (basketResume) => basketResume.resume.id === id
    );

    // Si le panier contient le CV: toast d'erreur
    if (isContaining) {
      props.cancelToast.current.show({
        severity: "error",
        summary: "error : ",
        detail: "Le panier contient déjà ce CV",
        life: 3000,
      });
      // Sinon ferme la fenêtre et ajoute le CV au panier dans l'API
    } else {
      props.handleUpdateCVs({
        isAddedResume: false,
        addedResumeId: null,
      });
      // URL de la requête POST
      let url = `${process.env.REACT_APP_BASE_URL_API}/basket_resumes/${basketId}/add_resumes`;
      const data = [`/api/cvs/${id}`];
      axios
        .post(url, data, {
          headers: props.auth.token
            ? {
                accept: "application/json",
                Authorization: `Bearer ${props.auth.token}`,
              }
            : {
                accept: "application/json",
              },
        })
        .catch((error) => {
          props.auth.toast?.current?.show({
            severity: "error",
            summary: "Erreur",
            detail: error?.response?.data?.detail || "Une erreur est survenue",
            life: 5000,
          });
        });
    }
  };

  // Fonction qui supprime un CV du panier (déclenchée dans la pop-up CV dans les paniers)
  const deleteResume = (cv) => {
    // modifie la liste d'id de CV associée au panier (déclenche le useEffect)
    newBasketResumeItems = newBasketResumeItems.filter(
      (resumeItem) => resumeItem.resume.id !== cv.id
    );

    // Suppression du lien entre le CV et le panier dans la base
    let url = `${process.env.REACT_APP_BASE_URL_API}/basket_resumes/${props.basketId}/delete_resumes`;
    const data = [`/api/cvs/${cv.id}`];
    axios
      .post(url, data, {
        headers: props.auth.token
          ? {
              accept: "application/json",
              Authorization: `Bearer ${props.auth.token}`,
            }
          : {
              accept: "application/json",
            },
      })
      .then((res) => {
        props.handleUpdateCVs({
          cvsBasket: props.cvs.cvsBasket.map((basket) => {
            if (basket.id === props.basketId) {
              return res.data;
            } else {
              return basket;
            }
          }),
        });
        props.cancelToast.current.show({
          severity: "error",
          summary: "suppression : ",
          detail: "Le CV a bien été supprimé du panier",
          life: 3000,
        });
      })
      .catch((error) => {
        props.auth.toast?.current?.show({
          severity: "error",
          summary: "Erreur",
          detail: error?.response?.data?.detail || "Une erreur est survenue",
          life: 5000,
        });
      });
  };

  const sendBasketToRecruiter = () => {
    let emailArray = emailList.split(",");
    emailArray = emailArray.map((x) => x.replace(/\s+/g, ""));

    axios
      .post(
        `${process.env.REACT_APP_BASE_URL_API}/basket_resumes/${props.basketId}/send`,
        { recruiterEmails: emailArray },
        {
          headers: props.auth.token
            ? {
                accept: "application/json",
                Authorization: `Bearer ${props.auth.token}`,
              }
            : {
                accept: "application/json",
              },
        }
      )
      .then(() => {
        setEmailList("");
        setVisibleModal(!visibleModal);
        props.auth.toast.current.show({
          severity: "success",
          summary: "Succès : ",
          detail: "Votre panier de CVs a bien été envoyé",
          life: 3000,
        });
      })
      .catch(() =>
        props.auth.toast.current.show({
          severity: "error",
          summary: "Erreur : ",
          detail: "Une erreur est survenue lors de l'envoi du panier de CVs",
          life: 3000,
        })
      );
  };
  return (
    <div>
      <div className="CVPanier__container cardHover">
        <div className="CVPanier">
          <div
            className="CVPanier__image"
            onClick={() => {
              // Si on clique su le panier depuis la pop-up dans la CVThèque lance la fonction addResume
              // Sinon ouvre la pop-up avec les CV contenu dans ce panier
              props.cvs.isAddedResume
                ? addResume(props.cvs.addedResumeId, props.basketId)
                : (setVisibleModalDetail(!visibleModalDetail),
                  createBasketResumeList());
            }}
          >
            <img
              src={API_LINK + props.basketImage}
              alt="Logo de l'université"
              title="Logo de l'université"
            />
          </div>
          <div className="CVPanier__content">
            <div className="CVPanier__content__top">
              <div
                className="CVPanier__content__top__title"
                onClick={() => {
                  // Si on clique su le panier depuis la pop-up dans la CVThèque lance la fonction addResume
                  // Sinon ouvre la pop-up avec les CV contenu dans ce panier
                  props.cvs.isAddedResume
                    ? addResume(props.cvs.addedResumeId, props.basketId)
                    : (setVisibleModalDetail(!visibleModalDetail),
                      createBasketResumeList());
                }}
              >
                <div className="CVPanier__content__top__title__principal">
                  {props.basketName}
                </div>
                {/* <p className="send_by">Envoyé par {props.expediteur}</p> */}
                <p className="nombre_cv">
                  {newBasketResumeItems.length} CV dans ce panier{" "}
                </p>
              </div>
              <div className="trash" onClick={() => props.onDelete()}>
                <div className="tooltip">
                  <FaTrash />
                </div>
              </div>
            </div>
            <div className="CVPanier__content__bottom">
              <p
                className="CVPanier__content__bottom__bleu"
                onClick={() => {
                  props.handleUpdateCVs({
                    isAddedFromBasket: true,
                    fromBasketId: props.basketId,
                  });
                  props.handleMenu({
                    activeItemCVTheque: props.items.itemsCVTheque.findIndex(
                      (v) => v.label == "Cv thèque"
                    ),
                  });
                }}
              >
                Ajouter des CV{" "}
              </p>
              <p
                className="CVPanier__content__bottom__bleu"
                onClick={() => setVisibleModal(!visibleModal)}
              >
                <FaPaperPlane />
                Envoyer{" "}
              </p>
            </div>
            {/* Pop-up d'envoit d'un panier de CV */}
            {visibleModal && (
              <Modal
                visible={visibleModal}
                setVisible={setVisibleModal}
                header="Envoyer un panier de CV"
              >
                <div className="modal_description">
                  <form action="/action_page.php">
                    <label>
                      Veuillez saisir le(s) mail(s) de recruteur(s) séparés
                      d&apos;une virgule
                    </label>
                    <InputText
                      //   type="text"
                      id="fname"
                      name="fname"
                      placeholder="mail 1, mail 2, ..."
                      value={emailList}
                      onChange={(e) => setEmailList(e.target.value)}
                    />
                  </form>
                </div>

                <div className="boutons_modal">
                  <BtnBlanc
                    btnTexte="Envoyer"
                    btnAction={() => sendBasketToRecruiter()}
                  />
                  <BtnBlanc
                    btnTexte="Annuler"
                    btnAction={() => setVisibleModal(!visibleModal)}
                  />
                </div>
              </Modal>
            )}
          </div>
        </div>
        {/* Pop-up des CV contenu dans le panier */}
        {visibleModalDetail && (
          <Modal
            visible={visibleModalDetail}
            setVisible={setVisibleModalDetail}
            header="Voici la liste des CV présents dans ce panier"
          >
            {basketResumeList.length > 0 ? (
              basketResumeList.map((resume) => (
                <div className="basket_resume_item" key={resume.id}>
                  <CV
                    firstname={resume.user.firstname}
                    surname={resume.user.surname}
                    titre={resume.user.profilTitle}
                    userId={resume.user.id}
                    educations={resume.educations}
                    roles={resume.user.userRoles}
                    displayFromBasket={true}
                    resumeId={resume.id}
                    imageUrl={
                      resume.user.imageUrl ? resume.user.imageUrl : null
                    }
                  />
                  <div className="trash" onClick={() => deleteResume(resume)}>
                    <div className="tooltip">
                      <FaTrash />
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="description_modal">
                <p className="description_modal__empty__basket">
                  Il n&apos;y a pas de CV dans ce panier
                </p>
              </div>
            )}
          </Modal>
        )}
      </div>
    </div>
  );
};

CVPanier.propTypes = {
  items: PropTypes.object,
  handleMenu: PropTypes.object,
  nom: PropTypes.string,
  prenom: PropTypes.string,
  titre: PropTypes.string,
  bookmark: PropTypes.bool,
  date: PropTypes.string,
  expediteur: PropTypes.string,
  basketName: PropTypes.string,
  basketId: PropTypes.number,
  cvs: PropTypes.object,
  handleUpdateCVs: PropTypes.func,
  users: PropTypes.object,
  onDelete: PropTypes.func,
  basketImage: PropTypes.string,
  auth: PropTypes.object,
  cancelToast: PropTypes.func,
};

const mapStateToProps = (state) => ({
  items: state.items,
  cvs: state.cvs,
  users: state.users,
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) => ({
  handleMenu: (value) => {
    dispatch(updateMenu(value));
  },
  handleUpdateCVs: (value) => {
    dispatch(updateCVs(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(CVPanier);
